import axios from '@/api/config'
import {
  typingEssayRuleAPI,
  typingEssayAPI,
  submitTypingEssayPracticeRecordAPI,
  submitTypingEssayTestRecordAPI
} from '@/api/typingAPI'
import {
  firstPracticedAPI
} from '@/api/authAPI'

const state = {
  unlocked: false,
  typingEssayPracticeRule: null,
  typingEssayTestRule: null,
  typingEssay: {
    essay_id: 0,
    essay: null
  },
  fetching: false,
  submitting: false,
  finish: false
}

const getters = {

}

const mutations = {
  setUnlocked (state, payload) {
    state.unlocked = payload
  },
  setTypingEssayPracticeRule (state, payload) {
    state.typingEssayPracticeRule = payload
  },
  setTypingEssayTestRule (state, payload) {
    state.typingEssayTestRule = payload
  },
  setTypingEssay (state, payload) {
    state.typingEssay = payload
    console.log('essay:', state.typingEssay)
  },
  setFetching (state, status) {
    state.fetching = status
  },
  setSubmitting (state, status) {
    state.submitting = status
  },
  setFinish (state, status) {
    state.finish = status
  }
}

const actions = {
  fetchTypingEssayRules ({ commit }, payload) {
    commit('setFetching', true)
    return new Promise((resolve, reject) => {
      axios.get(typingEssayRuleAPI)
        .then((response) => {
          commit('setUnlocked', response.data.unlocked)
          commit('setTypingEssayPracticeRule', response.data.practiceRule)
          commit('setTypingEssayTestRule', response.data.testRule)
          commit('setFetching', false)
          resolve('ok')
        })
    })
  },
  fetchTypingEssay ({ commit, state }) {
    commit('setFetching', true)
    return new Promise((resolve, reject) => {
      axios.get(`${typingEssayAPI}?lastEssayId=${state.typingEssay.essay_id}`)
        .then((response) => {
          commit('setTypingEssay', response.data)
          commit('setFetching', false)
          resolve(response.data)
        }).catch((error) => reject(error))
    })
  },
  submitTypingEssayPracticeRecord ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setSubmitting', true)
      axios.post(submitTypingEssayPracticeRecordAPI, {
        essay_id: payload.essay_id,
        selected_minute: payload.selected_minute,
        correct: payload.correct,
        incorrect: payload.incorrect,
        score: payload.score,
        complete_used_time: payload.complete_used_time,
        certified_level: payload.certified_level
      }).then((response) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setSubmitting', false)
        commit('setFinish', true)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  submitTypingEssayTestRecord ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setSubmitting', true)
      axios.post(submitTypingEssayTestRecordAPI, {
        essay_id: payload.essay_id,
        correct: payload.correct,
        incorrect: payload.incorrect,
        score: payload.score,
        complete_used_time: payload.complete_used_time,
        certified_level: payload.certified_level
      }).then((response) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setSubmitting', false)
        commit('setFinish', true)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
